var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrc20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2245_4945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6558 6.55463C17.7735 5.73992 16.5529 4.4958 15.5588 3.61345L15.5 3.57227C15.4021 3.49368 15.2917 3.43204 15.1735 3.38992C12.7764 2.94286 1.62055 0.857568 1.40291 0.884039C1.34192 0.89258 1.28363 0.914691 1.23232 0.948745L1.17644 0.992862C1.10763 1.06274 1.05536 1.14717 1.02349 1.23992L1.00879 1.27816V1.48698V1.51933C2.26467 5.01639 7.2235 16.4723 8.19997 19.1605C8.25879 19.3429 8.37056 19.6899 8.57938 19.7076H8.62644C8.7382 19.7076 9.21467 19.0782 9.21467 19.0782C9.21467 19.0782 17.7323 8.74874 18.5941 7.64875C18.7056 7.51325 18.8041 7.3675 18.8882 7.21345C18.9097 7.09292 18.8995 6.96888 18.8588 6.85343C18.8181 6.73797 18.7482 6.63503 18.6558 6.55463ZM11.4 7.75757L15.0353 4.74286L17.1676 6.70757L11.4 7.75757ZM9.9882 7.56051L3.72938 2.4311L13.8559 4.29874L9.9882 7.56051ZM10.5529 8.90463L16.9588 7.87227L9.63526 16.6958L10.5529 8.90463ZM2.87938 2.94286L9.46467 8.5311L8.51173 16.7017L2.87938 2.94286Z",
    fill: "#FF060A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2245_4945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.307617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrc20);
export default __webpack_public_path__ + "static/media/TRC20.a269803b55a67bb0a633f02d78942699.svg";
export { ForwardRef as ReactComponent };